import {SelectChangeEvent} from '@mui/material'
import {useState} from 'react'

export default function QuantityButton({
  product_id,
  value,
  onChange,
}: {
  product_id: string
  value: number
  onChange?: (sid: string, quantity: number) => void
}) {
  const [quantity, setQuantity] = useState(value)

  const handleIncrement = () => {
    if (quantity < 10) {
      setQuantity(quantity + 1)
      onChange && onChange(product_id, quantity + 1)
    }
  }

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1)
      onChange && onChange(product_id, quantity - 1)
    }
  }

  const handleChange = (e: SelectChangeEvent) => {
    const value = parseInt(e.target.value)
    if (!isNaN(value) && value >= 1 && value <= 10) {
      setQuantity(value)
      onChange && onChange(product_id, value)
    } else if (e.target.value === '') {
      setQuantity(1)
      onChange && onChange(product_id, 1)
    }
  }

  return (
    <div className='quantity-container'>
      <button onClick={handleDecrement} disabled={quantity <= 1}>
        -
      </button>
      <input type='number' value={quantity} onChange={handleChange} min={1} max={10} />
      <button onClick={handleIncrement} disabled={quantity >= 10}>
        +
      </button>
    </div>
  )
}
